import { gql } from '@apollo/client';

export const BENEFICIARIES_IN_MODALS = gql`
  query BeneficiariesInModals($input: StakeholderFilter) {
    stakeholders: getPeople(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          persalNumber
          nationalID
          cohorts {
            id
            name
            intervention {
              id
            }
          }
          institutions {
            id
            name
            emisNumber
          }
          primaryInstitution {
            id
            name
            emisNumber
          }
          grades {
            id
            value
            name
          }
          type {
            id
            name
          }
        }
        cursor
      }
    }
  }
`;
